import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EventsHubService } from '../services/events-hub.service';
import { AuthenticationService } from './authentication.service';
import { AuthData } from 'commons';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor, OnDestroy {

  private subscriptions: Subscription = new Subscription;
  private authData: AuthData | null = null;

  constructor(
    private readonly eventsHubService: EventsHubService,
    private readonly authenticationService: AuthenticationService,
  ) {
    this.getSubscriptions();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private getSubscriptions(): void {
    this.subscriptions.add(this.eventsHubService.loggedIn$.subscribe((response: AuthData | null) => { this.authData = response; }));
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/api/oauth/token')) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
      const loginReq = req.clone({ headers });
      return next.handle(loginReq);
    }

    let modifiedRequest: HttpRequest<any> = req;

    if (this.authData && req.url.includes('/api')) {
      if (!this.authenticationService.isTokenValid()) {
        return this.handleExpiredToken();
      }

      const headers = new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.authData.tokenInfo.access_token}`,
        'x-trace-id': this.authData.traceId || ''
      })
      modifiedRequest = req.clone({ headers });
    }

    return next.handle(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !error.url?.includes('/token')) {
          return this.handleExpiredToken();
        }
        return throwError(() => error);
      })
    );
  }

  private handleExpiredToken(): Observable<never> {
    this.authenticationService.logout();
    location.reload();
    return throwError(() => new Error('Token expired'));
  }

}
